import React, { useState, useEffect } from "react";
import moment from "moment";
import { Col, Form, Modal, Row, Tabs } from "antd";
import { ToothSample, User } from "../../../models";
import { AItem } from "../../../components/sample/AItem";
import { BItem } from "../../../components/sample/BItem";
import { loginInfo } from "../../../config";
import { buildSampleResult } from "../../../common";
interface PropsType {
  visible: boolean;
  update: Function;
  setInvisible: Function;
  editRecord: ToothSample;
}

export const SchoolFillin: React.FC<PropsType> = ({
  visible,
  update,
  setInvisible,
  editRecord,
}) => {
  const [age, setAge] = useState(5);
  useEffect(() => {
    setAge(editRecord.age);
  }, [editRecord]);
  const handlerOk = async () => {
    //let sample: ToothSample = await getTable("toothsample", editRecord.id);
    let sample: ToothSample = { ...editRecord };
    sample.fillinId = loginInfo.user.id;
    sample.fillinName = loginInfo.user.userName;
    sample.fillinDate = moment().format("YYYY-MM-DD HH:mm:ss");
    sample.status = "数据填报";
    if(sample.cat >= 0){
      sample.status = "检测";
      buildSampleResult(sample);
    }
    update(sample);
    setInvisible();
  };
  const handlerCancel = () => {
    setInvisible();
  };

  return (
    <>
      <Modal
        title="学校检测数据填报"
        visible={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText="保存"
        cancelText="取消"
      >
        <Row>
          <Col offset={4} span={16}>
            <Form
              layout="horizontal"
              labelCol={{ span: 12 }}
              wrapperCol={{ span: 12 }}
            >
              <Form.Item label="受检人编码:">
                <span>{editRecord.code}</span>
              </Form.Item>
              <Form.Item label="受检人信息:">
                <span>{`${editRecord.schoolName}->${editRecord.gradeName}->${editRecord.className}->${editRecord.name}`}</span>
              </Form.Item>
            </Form>
          </Col>
        </Row>
        <Row>
          <Tabs>
            <Tabs.TabPane tab="生物学因素" key="2">
              <AItem editRecord={editRecord} age={age} />
            </Tabs.TabPane>
            <Tabs.TabPane tab="保护性因素" key="3">
              <BItem editRecord={editRecord} />
            </Tabs.TabPane>
          </Tabs>
        </Row>
      </Modal>
    </>
  );
};
